export class SignInError extends Error {
  constructor() {
    super('errors.sign-in');
  }
}